<template>
  <header>
    <nav>
      <img
        v-if="showLinks"
        class="hamburger"
        src="@/assets/icon-hamburger.png"
        alt="Menu Icon"
        aria-haspopup="true"
        @click="toggleDrawer"
      >
      <LeftDrawer
        v-if="showLinks"
        :drawer-open="drawerOpen"
        @toggled="$emit('toggled', $event)"
      />
      <router-link
        class="logo-link"
        :aria-label="showLinks ? isEmployee ? 'Visit Dashboard Page' : 'Visit My Quotes Page' : 'Visit Login Page'"
        :to="showLinks ? isEmployee ? '/dashboard' : '/my-quotes' : '/'"
        :tabindex="isEmployee ? '-1' : '0'"
      >
        <img
          class="logo"
          alt="Short Action Customs' Logo"
          src="@/assets/logo-sac.png"
        >
      </router-link>
      <div
        v-if="showLinks"
        class="links"
        :class="{isCustomer: !isEmployee}"
      >
        <router-link
          v-if="isEmployee"
          to="/dashboard"
          tabindex="-1"
        >
          DASHBOARD
        </router-link>
        <router-link
          v-if="isEmployee"
          to="/quotes"
          tabindex="-1"
        >
          QUOTES
        </router-link>
        <router-link
          v-if="isEmployee"
          to="/orders"
          tabindex="-1"
        >
          ORDERS
        </router-link>
        <router-link
          v-if="isEmployee"
          to="/customers"
          tabindex="-1"
        >
          CUSTOMERS
        </router-link>
        <router-link
          v-if="isEmployee"
          to="/purchase-orders"
          tabindex="-1"
        >
          PURCHASE ORDERS
        </router-link>
        <router-link
          v-if="isEmployee"
          to="/inventory"
          tabindex="-1"
        >
          INVENTORY
        </router-link>
        <router-link
          v-if="!isEmployee"
          to="/my-orders"
        >
          MY ORDERS
        </router-link>
        <router-link
          v-if="!isEmployee"
          to="/my-quotes"
        >
          MY QUOTES
        </router-link>
        <ConfigurationDropdownMenu v-if="isEmployee" />
      </div>
      <AccountDropdownMenu
        v-if="showLinks"
        class="dropdown-menu"
        aria-haspopup="true"
        :tabindex="isEmployee ? '-1' : '0'"
      />
    </nav>
  </header>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import LeftDrawer from './Header.LeftDrawer.vue'
import AccountDropdownMenu from './Header.AccountDropdownMenu.vue'
import ConfigurationDropdownMenu from './Header.ConfigurationDropdownMenu.vue'
import { LOCAL_STORAGE_CONSTANTS } from '@/constants/localstorage.contstants'

export default defineComponent({
  name: 'Header',
  components: {
    AccountDropdownMenu,
    ConfigurationDropdownMenu,
    LeftDrawer
  },
  emits: ['toggled'],
  data() {
    const isEmployeeFlag = localStorage.getItem(LOCAL_STORAGE_CONSTANTS.isEmployee)
    const isEmployee = isEmployeeFlag !== null && isEmployeeFlag === 'true'

    return {
      drawerOpen: false,
      isEmployee
    }
  },
  computed: {
    showLinks(): boolean {
      return this.$route.meta.requiresLogin
    }
  },
  mounted() {
    window.addEventListener(LOCAL_STORAGE_CONSTANTS.eventName, this.onLocalStorageChanged)
  },
  unmounted() {
    window.removeEventListener(LOCAL_STORAGE_CONSTANTS.eventName, this.onLocalStorageChanged)
  },
  methods: {
    onLocalStorageChanged(): void {
      const isEmployeeFlag = localStorage.getItem(LOCAL_STORAGE_CONSTANTS.isEmployee)
      this.isEmployee = isEmployeeFlag !== null && isEmployeeFlag === 'true'
    },
    toggleDrawer(): void {
      this.drawerOpen = !this.drawerOpen
    }
  }
})
</script>

<style scoped lang="scss">

header {
  height: 94px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 500;
  box-shadow: 0 2px 10px #00000033;
  -ms-box-shadow: 0 2px 10px 0 #00000033;
  -webkit-box-shadow: 0 2px 10px 0 #00000033;
  background-color: $Color-white;

  @include desktop {
    height: 130px;
  }

  nav {
    display: flex;
    height: 94px;

    @include desktop {
      height: 130px;
    }

    > .hamburger {
      height: 24px;
      width: 24px;
      margin: auto 0 auto 15px;
      cursor: pointer;

      @include desktop {
        display: none;
        margin-right: auto;
      }
    }

    > .logo-link {
      height: 60px;
      margin: auto;

      @include desktop {
        margin-left: 25px;
        height: 96px;
      }

      > .logo {
        height: 60px;
        width: auto;

        @include desktop {
          height: 96px;
        }
      }
    }

    > .links {
      display: none;
      margin: auto 2.6em auto 0;

      @include desktop {
        display: flex;
      }

      &.isCustomer {
        margin-right: 0;
      }

      a {
        font-weight: bold;
        color: $Color-font-colored-background;
        text-decoration: none;
        margin-right: 2.6em;
        line-height: 25px;
        font-size: 16px;

        &.router-link-exact-active,
        &:hover {
          color: $Color-sac-orange;
        }
      }
    }

    > .dropdown-menu {
      margin: auto 15px auto 0;

      @include desktop {
        margin-right: 25px;
      }
    }
  }
}

</style>
